// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d456ce70","505":"b0812568"}[chunkId] + ".chunk.js";
};